import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1111ade8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1111ade8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111ade8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PhoneTelInput: require('/var/app/components/PhoneTelInput.vue').default,DragAndDropFile: require('/var/app/components/DragAndDropFile.vue').default})
